import { render, staticRenderFns } from "./WorkflowQueryGuidelinesModal.vue?vue&type=template&id=645dba95"
import script from "./WorkflowQueryGuidelinesModal.vue?vue&type=script&lang=js"
export * from "./WorkflowQueryGuidelinesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645dba95')) {
      api.createRecord('645dba95', component.options)
    } else {
      api.reload('645dba95', component.options)
    }
    module.hot.accept("./WorkflowQueryGuidelinesModal.vue?vue&type=template&id=645dba95", function () {
      api.rerender('645dba95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowQueryGuidelinesModal.vue"
export default component.exports